// extracted by mini-css-extract-plugin
export default {"bunnerFirst":"HomeBanner1_bunnerFirst__brXhk","bunnerFirst__txt":"HomeBanner1_bunnerFirst__txt__Od3I5","bunnerFirst__txt_container":"HomeBanner1_bunnerFirst__txt_container__sz+VG"};